<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入姓名" v-model="searchModel.name" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入编号" v-model="searchModel.number" />
            </a-form-item>
          </a-col>
          <!-- <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <a-input placeholder="请输入类型" v-model="searchModel.type" />
              </a-form-item>
            </a-col>
          </template> -->
          <a-col :md="6" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend" />
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'RoleSearchForm',
  mounted () {},
  data () {
    return {
      searchModel: {},
      advanced: false // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (model[item] === undefined) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
  }
}
</script>

<style scoped>
</style>
